import { Component, OnInit } from '@angular/core';
import { MyDatePickerModule, IMyDpOptions } from 'mydatepicker';
import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { Angular2CsvModule } from 'angular2-csv';
declare var getHexAscii: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as jsPDF from 'jspdf';
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import 'rxjs/Rx';
import {DatePipe} from "@angular/common";
import { map } from 'rxjs/operator/map';


@Component({
  selector: 'app-loan-int-certificate',
  templateUrl: './loan-int-certificate.component.html',
  styleUrls: ['./loan-int-certificate.component.css']
})
export class LoanIntCertificateComponent implements OnInit {

  public filterQuery = '';
    public rowsOnPage = 5;
    public sortBy = 'particulars';
    public sortOrder = 'asc';
isShow: string = 'page1';
  isShow1: string = 'page1';
   scoAccounts: any;
  scoAndLoanAccounts : any =[];
  loanAccounts : any = [];
  accountDigit :any ;
  fromDate : any;
   toDate : any;
    fromDate1 : any;
  isDisabled:boolean=false;
   toDate1 : any;
  loanacct : string ="";
  address1 : string ;
  address2 : string ;
  totalDebit : any ;
  totalCredit : any;
  totalAmount : any;
  crOrDr : any;
  space='  ';
   isError:boolean=false;
   error:string="";
  moduleType : string ='';
  fullName : string ='' ;
  clrBalanceStr : string ='';
  
 // loanStatementOfAccountResp : any=[];
    data: any [];
   

  loanAcct: any;
  loanacctNo: string = '';
  loanAccountHolderDetails : any =[];
  todatDate:any=[];
  excelOrPdfName : string ;
  showLoanAmount : string ='Hide';
  mytime:Date = new Date();
  currentYear:any= this.mytime.getUTCFullYear();
  currentDate:any= this.mytime.getUTCDate()+1;
  currentMonth:any= this.mytime.getUTCMonth() + 1;
  currentMonth1:any= this.mytime.getUTCMonth() + 7;
  fromyear=this.mytime.getUTCFullYear()-1;
  subBtnDisabled:boolean=false;
  fromDateNull : string ='';
  toDateNull : string='';
  messageForDate : string = '';
  messageForDate1 : string = '';
  messageForDate2 : string = '';
  fromGreaterCurrent : string ='';
  accountNull : string = '';
  statacct: string;
  formatedDate : string='';
  message: string;
  LoanIntData:any;
  
  constructor(private webService: CallBackEndService,
    private spinnerService: Ng4LoadingSpinnerService,
  
  ) {
  this.scoAccounts = JSON.parse(sessionStorage.getItem('scoAccounts'));
    this.scoAndLoanAccounts = JSON.parse(sessionStorage.getItem('scoAndLoanAccounts'));
    this.loanAccounts = JSON.parse(sessionStorage.getItem('loanAccounts'));
    console.log("loan account isss "+this.loanAccounts+"sc accounts iss "+this.scoAndLoanAccounts);
    
    
     this.loanAccounts = JSON.parse(sessionStorage.getItem('loanAccounts'));
    
     
    
    
    
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    this.loanacctNo=this.loanAccounts[0];
    request.param1 = getHexAscii('', this.loanacctNo);
    request.param2 = this.loanacctNo;
    if(this.loanacctNo === undefined ){
      this.isShow='RecordNotFound';
      this.message="Record Not Found";
    }
    else {

      this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
        
        if (data !== null && data.status === 'S200') {
          //this.transactionListRespTD=IbResponse;
          this.loanAcct = data.param5;
         
         // this.moduleType = data.param5.moduleType;
         // this.fullName = data.param5.fullName;
         // this.clrBalanceStr = data.param5.clrBalanceStr;
          this.isShow = 'page2';
          // this.showLoanAmount ='Hide';
        } else if (data !== null && data.status === 'S200') {
          //this.error = response.statusDescription;
        } else {
         // alert(data);
        }
      });
    }
    
   }

  ngOnInit() {
    }
  DownLoadPDF()
  {
     if(this.loanacct===null||this.loanacct===undefined||this.loanacct==="")
    {
      this.accountNull='no';
    }else
    {
      // var pdf = new jsPDF();
      // var a = ["1","2","3","4"] ;
      // var b = ["11","12","13","14"]; 
      this.spinnerService.show();
       const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    
    request.param1 = getHexAscii('', this.loanacct+sessionStorage.getItem('storedUserName')+sessionStorage.getItem('custNo'));
	request.param2 = this.loanacct;
  request.param3=sessionStorage.getItem('storedUserName');
  request.param4=sessionStorage.getItem('custNo');
       this.webService.getResponse(request, 'LoanIntCertificate').subscribe((data: IbResponse) => {
         this.spinnerService.hide();
        if (data !== null && data.status === 'S200') {
          this.isError=false;
          this.error = '';
          //this.transactionListRespTD=IbResponse;
          console.log("response received");
           this.LoanIntData=data.param5;
          this.downloadPdf();
          for(const [key1, value1] of Object.entries( data.param5))
          {

           console.log("key--"+key1+"  value11---"+ JSON.stringify(value1));
          }
          

          console.log("map-data---------------"+data.param5);
          // pdf.setFontSize(8);
          // pdf.text(a,"test pdf ");
          // pdf.text(b,"hh-------------------------");
          // pdf.save();




         // this.loanAcct = data.param5;
          // this.moduleType = data.param5.moduleType;
          // this.fullName = data.param5.fullName;
          // this.clrBalanceStr = data.param5.clrBalanceStr;
          this.isShow = 'page2';
          // this.showLoanAmount ='Hide';
        } else if (data != null && data.status != 'S200') {
          this.isError=true;
          this.error = data.param1;
        } else {
          this.isError=true;
          this.error = 'Something Went Wrong,Please Try Again.';
        }
      });
    }

  }
  removestacctMessage()
  {
 this.accountNull='';
 }
  validateAccNo()
  {
    if(this.loanacct===null||this.loanacct===undefined||this.loanacct==="")
    {
      this.accountNull='no';
    }
  }

  dateconvert(monthNumber) { //1 = January
    var monthNames = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
      'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
    return monthNames[monthNumber - 1];
  }
  downloadPdf() {
    try{
 this.spinnerService.show();
    var pdf = new jsPDF();
     var a = Number(20 || 0);
            var b = Number(8 || 0); 
            var c = Number(30 || 0);
            var d = Number(20 || 0);
            var e = Number(193 || 0);
            var f = Number(35 || 0);
            var g = Number(8 || 0);
            var h = Number(2 || 0); 
            var i = Number(1 || 0);
           var s = Number(5 || 0);
      
         //  pdf.setFontSize(12);
       // pdf.text(70, a+2, 'LOAN Interest Certificate '); a=a+g; d=d+g;
        pdf.setFontSize(11);
        let today=new Date();
        this.todatDate=today.toDateString().split(' ');


        //this.fromDate=this.LoanIntData.prmFromDate;
       // this.toDate=this.LoanIntData.prmToDate;
        //let fromDate=this.fromDate.date.day + "-" +this.dateconvert( this.fromDate.date.month)+ "-" + this.fromDate.date.year;
       // let toDate= this.toDate.date.day + "-" + this.dateconvert(this.toDate.date.month) + "-" + this.toDate.date.year;
        pdf.text(h+162, a, 'Date : '+this.todatDate[2]+"-"+this.todatDate[1]+"-"+this.todatDate[3]); a=a+g; d=d+g;
        pdf.text(20,a," ");a=a+b;d=d+b;
        pdf.text(70, a,'"'+'Loan Interest Certificate'+'"'); a=a+g; d=d+g;
       
        pdf.text(20, a,"To,"); a=a+g; d=d+g;
        ///pdf.text(22, a," This is to certify that the following amount have been accured and/or have been paid on the undermentioned "); a=a+g; d=d+g
        //pdf.text(15, a,"Term Deposits during peroid from "+this.LoanIntData.prmFromDate+" to "+this.LoanIntData.prmToDate+"of "); a=a+b; d=d+b;
        pdf.text(25, a,this.LoanIntData.name.trim()); a=a+g; d=d+g;
        if(this.LoanIntData.add1!=null && this.LoanIntData.add1!=undefined && this.LoanIntData.add1!==''){
          pdf.text(25, a,this.LoanIntData.add1); a=a+b; d=d+b;
        }
       
        if(this.LoanIntData.add2!=null && this.LoanIntData.add2!=undefined && this.LoanIntData.add2!==''){
          pdf.text(25, a,this.LoanIntData.add2);a=a+b; d=d+b;
        }

        if(this.LoanIntData.add3!=null && this.LoanIntData.add3!=undefined && this.LoanIntData.add3!==''){
          pdf.text(25, a,this.LoanIntData.add3);a=a+b; d=d+b;
        }
       
        pdf.text(25, a,this.LoanIntData.cityAndCode);a=a+b; d=d+b;
        pdf.text(25,a,"Account Number: "+this.LoanIntData.accountNo+"                      "+this.LoanIntData.ProductMasterName);a=a+b; d=d+b;
       // pdf.text(h+165,a-2,this.LoanIntData.ProductMasterName);a=a+b;d=d+b;
       
        pdf.text(20,a," ");a=a+b;d=d+b;
       
        pdf.text(35,a,"This Is To Certify That We Have Granted A Loan of "+"Rs."+this.LoanIntData.sanctionLimit+" on "+this.LoanIntData.sanctionDate);a=a+b;d=d+b;
        //pdf.text(20,a,"RS."+this.LoanIntData.sanctionLimit+" on "+this.LoanIntData.sanctionDate+" to "+this.LoanIntData.name);a=a+b;d=d+b;
        pdf.text(20,a," to "+this.LoanIntData.name.trim()+" For The Purpose of "+this.LoanIntData.ProductMasterName+".");a=a+b;d=d+b;
     
        pdf.text(20,a-2," ");a=a+b;d=d+b;
        pdf.text(35,a,"In This Regards We Have To Inform You As Follows.");a=a+b;d=d+b;
        pdf.text(20,a,"Balance As On "+this.LoanIntData.operationDate+"                                                          "+this.LoanIntData.PrincipalAmt);a=a+b;d=d+b;
        pdf.text(20,a,"Interest Debite from "+this.LoanIntData.prmFromDate+" To "+this.LoanIntData.prmToDate+"                          "+this.LoanIntData.wsTotDr);a=a+b;d=d+b;
        pdf.text(20,a,"Total Repayment from "+this.LoanIntData.prmFromDate+" To "+this.LoanIntData.prmToDate+"                      "+this.LoanIntData.wsTotRepayAmt);a=a+b;d=d+b;
        pdf.text(20,a-2," ");a=a+b;d=d+b;
        pdf.text(20,a,"Appreciate Towards");a=a+b;d=d+b;
        pdf.text(20,a,"Principal Amount "+"                                                                         "+this.LoanIntData.wsPrinAmtActCr);a=a+b;d=d+b;
        pdf.text(20,a,"Interest Amount   "+"                                                                         "+this.LoanIntData.wsIntAmtActCr);a=a+b;d=d+b;
      
       pdf.text(20,a-2," ");a=a+b;d=d+b;

        pdf.text(20,a,"Principal Amount Projected "+"                                                         "+this.LoanIntData.wsPrinAmtProjCr);a=a+b;d=d+b;
        pdf.text(20,a,"Interest Amount Projected  "+"                                                          "+this.LoanIntData.wsIntAmtProjCr);a=a+b;d=d+b;
        


      //  pdf.text(35, a-2,this.LoanIntData.prmFromDate);a=a+b; d=d+b;
       // pdf.text(35, a-2,this.LoanIntData.add3);a=a+b; d=d+b;
     //   pdf.text(35, a-2,this.LoanIntData.prmFromDate);a=a+b; d=d+b;
      // pdf.text(35, a+54,this.TDAccountaddress.area);a=a+b; d=d+b;
       //  pdf.text(35, a-2,this.LoanIntData.cityAndCode);a=a+b; d=d+b;
       
        c=d+5;
       
         //pdf.line(h+5, a-3, e, a-3);
         
           
    
        // pdf.text(h+40, a+20, 'Note: Closed Recipts are not considered under Total Principal Amount');
        
        // a=a+s;
        // pdf.text(h, a, 'No. of recipts');
        // pdf.text(h+123, a,'');
        // pdf.line(h, a-3, e, a-3); 
        
            
    
        a=a+s;
        ///pdf.line(h, a-3, e, a-3); 
       var img = new Image;
        img.onload = function() {
          pdf.setPage(1);
            pdf.addImage(this, 2, 5, 100, 17);
            pdf.save("Loan Interest Certificate"+".pdf");
        };
        img.crossOrigin = "";
        img.src = 'assets/img/LogoWithName.png';
    this.spinnerService.hide();
    }catch(e){
      this.spinnerService.hide();
    }
  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/loan-int-certificate/loan-int-certificate.component.ts